/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveLine } from "@nivo/line";
import { ResponsiveRadialBar } from "@nivo/radial-bar";
import dayjs from "dayjs";
import { Row, Col, Card, Tag, DatePicker, Button } from "antd";
import { postRequest } from "api";
import { ba, dashboard } from "api/endpoints";
import { CustomTable } from "components";
import { UnorderedListOutlined } from "@ant-design/icons";
import { formatCurrency, formatDate, formatDateTime, formatDateTimeUtc } from "utils/formatter";
import { toHex } from "utils";
import empty from "assets/images/empty-box.png";
import { useMediaQuery } from "react-responsive";

const Dashboard = () => {
  const navigate = useNavigate();

  const isXLargeScreen = useMediaQuery({ minWidth: 1200 });
  const isLimit5 = useMediaQuery({ minWidth: 1600 });
  const test = useMediaQuery({ minWidth: 1600 });
  const [lmt, setLmt] = useState(0);

  const [refresh, setRefresh] = useState(Date.now());
  const [cust, setCust] = useState([]);
  const [cntr, setCntr] = useState([]);
  const [err, setErr] = useState([]);
  const [searchVal, setSearchVal] = useState({
    Year: 2023,
    Month: 9,
  });

  const confirm = async (date) => {
    setSearchVal({ ...searchVal, Year: formatDateTime(date).split(".")[0], Month: formatDateTime(date).split(".")[1] });
  };

  const stmtCol = [
    {
      title: "Огноо",
      dataIndex: "TxnDate",
      render: (_, rec) => formatDate(rec.BankTxnDate),
    },
    {
      title: "Дүн",
      dataIndex: "TxnAmt",
      render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
    },
    {
      title: "Данс",
      dataIndex: "RelatedAcnt",
      textAlign: "center",
      filter: {},
    },
    {
      title: "Огноо",
      dataIndex: "rngdate",
      width: "150px",
      render: (_, rec) => <div style={{ textAlign: "center", width: "150px" }}>{formatDateTimeUtc(rec.CreatedAt)}</div>,
    },
    {
      title: "Төрөл",
      dataIndex: "TxnType",
      render: (val, rec) => <Tag color={val === "IN" ? "green" : "red"}>{rec.TxnTypeName}</Tag>,
      filter: {
        type: "select",
        dtSrc: [
          { val: "IN", txt: "Орлого" },
          { val: "OUT", txt: "Зарлага" },
        ],
      },
    },
    {
      title: "Төлөв",
      dataIndex: "Status",
      render: (_, rec) => <Tag color={"#" + toHex(rec.StatusName).slice(9, 15)}>{rec.StatusName}</Tag>,
      filter: {
        type: "select",
        dtSrc: [
          { val: "UNRECOGNIZED", txt: "Тодорхойгүй" },
          { val: "FAILED", txt: "Алдаатай" },
          { val: "READ", txt: "Уншсан" },
          { val: "NEW", txt: "Шинэ" },
          { val: "SUCCESS", txt: "Амжилттай" },
        ],
      },
    },
  ];

  const checkLabel = (label, type) => {
    if (type === "baStmt") {
      switch (label) {
        case "UNRECOGNIZED":
          return { name: "Тодорхойгүй", color: "#81ccff" };
        case "FAILED":
          return { name: "Алдаатай", color: "#cb2121" };
        case "READ":
          return { name: "Уншсан", color: "#6b925f" };
        case "NEW":
          return { name: "Шинэ", color: "#006994" };
        default:
          return { name: "Амжилттай", color: "#198754" };
      }
    } else if (type === "cust") {
      switch (label) {
        case "None":
          return { name: "Шинэ", color: "#006994" };
        case "Sent":
          return { name: "Илгээсэн", color: "#00ff00" };
        case "ReSent":
          return { name: "Дахин илгээсэн", color: "#ff4500" };
        case "ExtSent":
          return { name: "Сунгах хүсэлт", color: "#6b925f" };
        case "Allow":
          return { name: "Зөвшөөрсөн", color: "#ffd700" };
        case "Return":
          return { name: "Буцаагдсан", color: "#741313" };
        default:
          return { name: "Татгалзсан", color: "#7c0a02" };
      }
    } else if (type === "rqst") {
      switch (label) {
        case "NEW":
          return { name: "Шинэ", color: "#006994" };
        case "SENT":
          return { name: "Илгээсэн", color: "#00ff00" };
        case "TRANSFERRED":
          return { name: "Шилжүүлсэн", color: "#ff85bc" };
        default:
          return { name: "Амжилттай", color: "#198754" };
      }
    }
  };

  useEffect(() => {
    getCntrCount();
  }, [searchVal]);

  useEffect(() => {
    if (isLimit5) {
      console.log(5);
      setLmt(5);
    } else {
      console.log(3);
      setLmt(3);
    }
    setRefresh(Date.now());
  }, [isLimit5]);

  const getFintData = async () => {
    try {
      const res = await postRequest(dashboard.fint, {
        FirstDate: dayjs(Date.now()).format("YYYY-MM-DD"),
        SecondDate: dayjs(Date.now()).add(1, "day").format("YYYY-MM-DD"),
      });
      const temp = [];
      if (res.data.Data !== undefined) {
        res.data.Data.map((el) => {
          let stmt = checkLabel(el.CntrRqst, "cust");
          temp.push({
            id: stmt.name,
            label: stmt.name,
            value: el.Count,
            color: stmt.color,
          });
        });
        setCust(temp);
      } else {
        setCust([]);
      }
    } catch (error) {}
  };

  const getCntrCount = async () => {
    try {
      const res = await postRequest(dashboard.cntrCount, {
        Year: +searchVal.Year,
        Month: +searchVal.Month,
      });
      const temp = [
        {
          id: "Гэрээний тоо",
          data: [],
        },
      ];
      if (res.data.Data !== undefined) {
        res.data.Data.map((el) => {
          let name = el.Date.split(" ")[0].substring(8);
          temp[0].data.push({
            x: name,
            y: el.Count,
          });
        });
        setCntr(temp);
      } else {
        setCntr([]);
      }
    } catch (error) {}
  };

  const getErrCount = async () => {
    try {
      const res = await postRequest(dashboard.errCount);

      const temp = [];

      if (res.data.Data !== undefined) {
        res.data.Data.map((el) => {
          temp.push({
            id: el.Name,
            data: [
              {
                x: el.Name,
                y: el.Count,
              },
            ],
          });
        });
        setErr(temp);
      } else {
        setErr([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getFintData();
    getCntrCount();
    getErrCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Col style={{ height: "100vh", w: "100vw", padding: "30px 15px" }}>
      <Row
        gutter={[24, 40]}
        style={{ height: isXLargeScreen ? "45%" : "90%", marginBottom: isXLargeScreen ? "40px" : "80px" }}
      >
        <Col sm={24} md={24} xl={10} style={{ height: isXLargeScreen ? "100%" : "50%" }}>
          <Card style={{ borderRadius: "30px", height: "105%" }}>
            <div style={{ fontSize: "20px", fontWeight: "bold" }}>Онлайн гэрээний хүсэлт</div>
            {cust.length > 0 ? (
              <div style={{ height: test ? "350px" : "250px" }}>
                <ResponsivePie
                  data={cust}
                  margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                  startAngle={-150}
                  innerRadius={0.8}
                  padAngle={1}
                  cornerRadius={17}
                  activeOuterRadiusOffset={8}
                  borderWidth={1}
                  borderColor={{ theme: "background" }}
                  arcLinkLabelsSkipAngle={10}
                  arcLinkLabelsTextColor="#333333"
                  arcLinkLabelsThickness={2}
                  arcLinkLabelsColor={{ from: "color" }}
                  arcLabelsSkipAngle={10}
                  arcLabelsTextColor={{
                    from: "color",
                    modifiers: [["darker", 2]],
                  }}
                  defs={[
                    {
                      id: "dots",
                      type: "patternDots",
                      background: "inherit",
                      color: "rgba(255, 255, 255, 0.3)",
                      size: 4,
                      padding: 1,
                      stagger: true,
                    },
                    {
                      id: "lines",
                      type: "patternLines",
                      background: "inherit",
                      color: "rgba(255, 255, 255, 0.3)",
                      rotation: -45,
                      lineWidth: 6,
                      spacing: 10,
                    },
                  ]}
                  legends={[
                    {
                      anchor: "bottom",
                      direction: "row",
                      justify: false,
                      translateX: 0,
                      translateY: 56,
                      itemsSpacing: 0,
                      itemWidth: test ? 120 : 108,
                      itemHeight: 18,
                      itemTextColor: "#999",
                      itemDirection: "left-to-right",
                      itemOpacity: 1,
                      symbolSize: 18,
                      symbolShape: "circle",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemTextColor: "#000",
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
            ) : (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={empty} alt="empty" width={"150px"} />
              </div>
            )}
          </Card>
        </Col>
        <Col sm={24} md={24} xl={14} style={{ height: isXLargeScreen ? "100%" : "50%" }}>
          <Card style={{ borderRadius: "30px", height: "105%" }}>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "15px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>Банкны хуулга</div>

              <Button
                type="primary"
                onClick={() => {
                  const filter = window.location.href.split("?")[1];
                  if (filter === undefined) {
                    navigate(ba.stmts);
                  } else {
                    navigate(`${ba.stmts}?${filter}`);
                  }
                }}
              >
                <UnorderedListOutlined />
              </Button>
            </div>

            <CustomTable
              limit={lmt}
              columns={stmtCol}
              endpoints={ba.stmts}
              primaryKey={"RecNo"}
              actionCol={false}
              isPost={true}
              refresh={refresh}
              filters={{ Status: "UNRECOGNIZED" }}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[24, 30]} style={{ height: isXLargeScreen ? "45%" : "90%" }}>
        <Col sm={24} md={24} xl={8} style={{ height: isXLargeScreen ? "100%" : "50%" }}>
          <Card style={{ borderRadius: "30px", height: "100%" }}>
            <div style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "15px" }}>Алдааны жагсаалт</div>
            {err.length > 0 ? (
              <div style={{ height: test ? "350px" : "250px" }}>
                <ResponsiveRadialBar
                  data={err}
                  valueFormat=">-.2f"
                  padding={0.1}
                  cornerRadius={2}
                  innerRadius={0.1}
                  margin={{ top: 10, right: 150, bottom: 40, left: 55 }}
                  colors={{ scheme: "category10" }}
                  radialAxisStart={{ tickSize: 5, tickPadding: 5, tickRotation: 0 }}
                  circularAxisOuter={{ tickSize: 5, tickPadding: 12, tickRotation: 0 }}
                  legends={[
                    {
                      anchor: "right",
                      direction: "column",
                      justify: false,
                      translateX: 150,
                      translateY: 0,
                      itemsSpacing: 6,
                      itemDirection: "left-to-right",
                      itemWidth: 100,
                      itemHeight: 12,
                      itemTextColor: "#999",
                      symbolSize: 18,
                      symbolShape: "square",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemTextColor: "#000",
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
            ) : (
              <div
                style={{
                  height: test ? "350px" : "250px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={empty} alt="empty" width={"150px"} />
              </div>
            )}
          </Card>
        </Col>
        <Col sm={24} md={24} xl={16} style={{ height: isXLargeScreen ? "100%" : "50%" }}>
          <Card style={{ borderRadius: "30px", height: "100%" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginRight: "110px" }}>
              <div style={{ fontSize: "20px", fontWeight: "bold" }}>Гэрээний тоо</div>
              <div style={{ width: "80px" }}>
                <DatePicker picker="month" onChange={confirm} placeholder="Сар" />
              </div>
            </div>
            {cntr.length > 0 ? (
              <div style={{ height: test ? "350px" : "250px" }}>
                <ResponsiveLine
                  data={cntr}
                  margin={{ top: 30, right: 110, bottom: 80, left: 60 }}
                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: true,
                    reverse: false,
                  }}
                  yFormat=" >-.2f"
                  curve="cardinal"
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    tickSize: 20,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Хоног",
                    legendOffset: 50,
                    legendPosition: "middle",
                  }}
                  axisLeft={{
                    tickSize: 20,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Тоо",
                    legendOffset: -50,
                    legendPosition: "middle",
                  }}
                  pointSize={10}
                  enablePointLabel={true}
                  pointColor={{ theme: "background" }}
                  pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 100,
                      translateY: 0,
                      itemsSpacing: 0,
                      itemDirection: "left-to-right",
                      itemWidth: 80,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: "circle",
                      symbolBorderColor: "rgba(0, 0, 0, .5)",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemBackground: "rgba(0, 0, 0, .03)",
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                />
              </div>
            ) : (
              <div
                style={{
                  height: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={empty} alt="empty" width={"150px"} />
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Col>
  );
};

export default Dashboard;
